import { LANGUAGE_PREFERENCES_VERSION } from './constants';

export type LanguageCode = 'en' | 'id';

export interface LanguagePreferences {
  languageCode: LanguageCode;
  version: number;
  updatedAt?: string;
}

export const DEFAULT_LANGUAGE_PREFERENCES: LanguagePreferences = {
  languageCode: 'en',
  version: LANGUAGE_PREFERENCES_VERSION,
};
